module.exports = __webpack_public_path__ + "static/media/africa_getty.ea27c2a4.jpg";